import React from "react";
import axios from "axios";
import {PodcastsFilter} from "../components/shared/Filter"
import {PodcastResults} from "../components/shared/Result"
import {Pagination} from "../components/shared/Pagination"

export default function Podcasts({keywords, urlPrefix, currentPage, timeFilter, durationFilter, sortByFilter}) {
  const [loading, setLoading] = React.useState(true)
  const [results, setResults] = React.useState(null)

  const itemsPerPages = 40;
  const totalPages = !loading && results && (results.episodes || []).length < itemsPerPages ? currentPage : 10;

  React.useEffect(()=>{
    axios.get(`https://api.edifi.app/api/search?api_version=1&k=${keywords}&type=episodes&fb_lang=${process.env.REACT_APP_DEFAULT_LOCALE}&duration=${durationFilter}&published_since=${timeFilter}&order_by=${{'': 'relevancy', 'pdt': 'published_at'}[sortByFilter]}&offset=${itemsPerPages*(currentPage-1)}&limit=${itemsPerPages}`).then((response) => {
      setResults(response.data);
    }).catch((error) => {
      // handle error
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  }, [])

  return (
    <main className="search-ct-full" role="main">
      <PodcastsFilter timeFilter={timeFilter} durationFilter={durationFilter} sortByFilter={sortByFilter} urlPrefix={urlPrefix}/>
      <div className="spacing-b-lg">
          {loading &&
            <ul className="news-list list divider md no-bullet"><li><div className="quiet fz13">loading...</div></li></ul>
          }
          {!loading && results && (results.episodes || []).length === 0 &&
            <ul className="news-list list divider md no-bullet"><li><div className="quiet fz13">No {currentPage === 1 ? '' : 'more '}results found for "<strong>{keywords}</strong>".</div></li></ul>
          }
          {!loading && results &&
            <PodcastResults items={results.episodes} />
          }
          {!loading && results && (results.episodes || []).length !== 0 &&
            <Pagination currentPage={currentPage} totalPages={totalPages} />
          }
      </div>
    </main>
  );
}
